"use strict";

(function () {

  angular.module("fleetviewApp").filter("moment", [function () {
    return function (date, method) {
      var momented = moment(date);
      return momented[method].apply(momented, Array.prototype.slice.call(arguments, 2));
    };
  }]);

  angular.module("fleetviewApp").filter("momentParse", [function () {
    return function (date, format) {
      return moment(date, format);
    };
  }]);

  angular.module("fleetviewApp").directive("showFocus", ['$timeout', function ($timeout) {
    return function (scope, element, attrs) {
      scope.$watch(attrs.showFocus, function (newValue) {
        $timeout(function () {
          newValue && element.focus();
        });
      }, true);
    };
  }]);

  angular.module("fleetviewApp").directive('focusOn', function ($timeout) {
    return {
      restrict: 'A',
      link: function link($scope, $element, $attr) {
        $scope.$watch($attr.focusOn, function (_focusVal) {
          $timeout(function () {
            _focusVal ? $element.focus() : $element.blur();
          });
        });
      }
    };
  });

  angular.module("fleetviewApp").directive('emptyToNull', function () {
    return {
      restrict: 'A',
      require: 'ngModel',
      link: function link(scope, elem, attrs, ctrl) {
        ctrl.$parsers.push(function (viewValue) {
          if (viewValue === "") {
            return null;
          }
          return viewValue;
        });
      }
    };
  });
})();


// WEBPACK FOOTER //
// ./app/components/other.directives.js